import { Components } from "@mui/material/styles";
import { Grey, White } from "@themes:palette";

export default {
  MuiAutocomplete: {
    defaultProps: {
      size: "small",
    },
    styleOverrides: {
      root: {
        borderRadius: 7,
        borderWidth: 0,
        "&.with-bg": {
          "& .MuiInputBase-root": {
            backgroundColor: Grey[50],
          },
          "& .Mui-focused": {
            backgroundColor: White,
          },
        },
        "& .MuiOutlinedInput-root": {
          borderRadius: 7,
          fieldset: {
            borderWidth: 0,
          },
        },
      },
    },
  } as Components["MuiAutocomplete"],
};
